'use strict';
import register from './core';
import '../functions/jquery-global.js';
import { keys } from '../functions/search-common';

register('projectform-person-search', function (element) {
  const wrapper = $(element);
  const textInput = $(".projectform-person-search-input", wrapper);
  let allowMultiple = wrapper.attr('data-allow-multiple') ? true : false;
  let peopleValues = $(".projectform-person-search-value", wrapper);
  const resultContainer = $(".result-container", wrapper);
  let selected = $(".selected-people", wrapper)[0];
  let delayTimer;
  let inputKeyDownInit = false;
  let listIndex = -1;
  let currentQuery = "";
  const noResultsMsg = wrapper.attr("data-no-result-msg");
  const allowOneNameMsg = wrapper.attr("allow-one-name-msg");
  let allowSingleMsg = document.createElement('p');


  const getCurrentResultItems = function () {
    return resultContainer.find($("li"))
  };

  function inputKeyDown(e) {
    let items = getCurrentResultItems();

    let kc = e.keyCode;
    if (e.keyCode != keys.tab) {
      e.preventDefault();
    }

    var isArrowsPressed = (kc === keys.enter || kc === keys.up || kc === keys.down);
    if (!isArrowsPressed)
      return;

    var firstIndex = 0;
    var lastIndex = items.length - 1;
    items.removeClass("selected");

    switch (kc) {
      case keys.down:
        listIndex++;
        break;
      case keys.up:
        listIndex--;
        break;
      case keys.enter:
        resultElementClickEvent(items.eq(listIndex), e);
        break;
    }

    if (listIndex > lastIndex)
      listIndex = firstIndex;
    else if (listIndex < firstIndex)
      listIndex = lastIndex;

    if (listIndex !== -1)
      items.eq(listIndex).addClass("selected");
    inputKeyDownInit = true;
  }

  function doSearch(q) {
    if (q.length < 4) {
      resultContainer.html("");
      return;
    }
    if (currentQuery == q) return;
    
    clearTimeout(delayTimer);
    delayTimer = setTimeout(() => fetchPeople(q), 400);
  }

  function resultElementClickEvent(resultElement, e) {
    e.preventDefault();

    let userId = $(resultElement).attr("data-userid");
    let displayName = $(resultElement).attr("data-displayname");

    if (personAlreadyAdded(userId) || peopleLimitReached())
      return;

    let selectedElement = createSelectedElement(userId, displayName);
    let deleteIcon = getDeleteIcon();
    selectedElement.appendChild(deleteIcon);

    currentQuery = "";
    textInput.val("");
    textInput.focus();
    resultContainer.html("");
    addToSelectedElements(selectedElement);
    peopleValues.val(peopleValues.val() + (peopleValues.val().length > 0 ? "," : "") + userId);
  };

  function selectedElementClickEvent(selectedElement, e) {
    e.preventDefault();
    let userId = selectedElement.attr("data-selectedelement");
    let updatedPeople = removeValue(peopleValues.val(), userId);
    allowSingleMsg.style.display = 'none';
    peopleValues.val(updatedPeople);
    selectedElement.remove();

    if (updatedPeople == 0) {
      selected.style.display = 'none'
    }
    textInput.attr('disabled', false);
    textInput.focus();
  };

  function addToSelectedElements(selectedElement) {
    let selectedPeople = $(".selected-people", wrapper);
    selectedPeople.append(selectedElement);
    if (!allowMultiple) {
      textInput.attr('disabled', true);
 
      // Displays helper message to user
      allowSingleMsg.style.display = 'inherit';
      allowSingleMsg.innerText = allowOneNameMsg
      resultContainer.append(allowSingleMsg)
    }
    
  }

  function removeValue(array, toRemove) {
    let elements = array.split(",");
    let removeIndex = elements.indexOf(toRemove);
    elements.splice(removeIndex, 1);
    let result = elements.join(",");
    return result;
  }

  function personAlreadyAdded(userId) {
    let alreadyAdded = isExactMatch(peopleValues.val(), userId);
    return alreadyAdded;
  }

  function escapeRegExpMatch(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  function getDeleteIcon() {
    let deleteIcon = document.createElement("div");
    deleteIcon.innerHTML = '<svg><use xlink:href="#icon-close"/></svg>';
    deleteIcon.classList.add("selected-element-delete-icon");
    return deleteIcon.firstChild;
  }

  function isExactMatch(str, match) {
    return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str)
  }

  function peopleLimitReached() {
    if (!allowMultiple && peopleValues.val().length > 1)
      return true;
    return false;
  }

  function createResultElement(person) {
    let resultElement = document.createElement("li");
    $(resultElement).attr("data-userid", person.UserId)
    $(resultElement).attr("data-displayname", getPersonDisplayName(person))
    $(resultElement).attr("data-resultelement", person.UserId)
    resultElement.innerText = getPersonDisplayName(person)
    return resultElement;
  }

  function createSelectedElement(userId, displayName) {
    let selectedPerson = document.createElement("li");
    $(selectedPerson).attr("data-selectedelement", userId);
    selectedPerson.className += " button button--transparent button--black button--project-form";
    selected.style.display = 'inherit';
    selectedPerson.innerText = displayName;
    return selectedPerson;
  }

  function getPersonDisplayName(person) {
    return person.Name + " [" + person.UserId + "]";
  }

  function fetchPeople(q) {   
    $.ajax({
      type: 'GET',
      url: '/api/ProjectFormApi/GetPeople?query=' + q,
      success: function (result) {
        resultContainer.html("");
        if (result.people && result.people.length) {
          for (let i = 0; i < result.people.length; i++) {

            // Create element and append it to the list of results below the input field
            let person = result.people[i];
            let resultElement = createResultElement(person);
            resultContainer.append(resultElement);
            // Resets listIndex on every search
            listIndex = -1;
          }

          if (!inputKeyDownInit) {
            textInput.on('keyup', (function (e) {
              inputKeyDown(e);
              return false;
            }))
          }
        }
        else {
          let noResultParagraph = document.createElement('p')
          noResultParagraph.innerHTML = noResultsMsg;
          resultContainer.append(noResultParagraph)
        }
      },
      error: function (xhr) {
        if (xhr.status === 400) {
          console.log("fail")
        }
        else if (xhr.status === 404) {
          console.log("fail")
        }
      }
    });
    currentQuery = q;
  }

  // EventListeners
  $(wrapper).on('click', '[data-resultelement]', function (e) {
    e.preventDefault();
    resultElementClickEvent($(this), e);
  });

  $(wrapper).on('click', '[data-selectedelement]', function (e) {
    e.preventDefault();
    allowSingleMsg.style.display = 'none';
    selectedElementClickEvent($(this), e);
  });

  // Prevents form from submit on press enter
  textInput.keydown(function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      return false;
    }
  });
 
  textInput.keyup(function (e) {
    e.preventDefault();
    doSearch(e.target.value);
  });
});
